import { createFileRoute } from "@tanstack/react-router";

import { Pager } from "@/components/pager";
import { QueryState } from "@/components/query-state";
import { pageSearch } from "@/features/opportunities/search";
import { PoolTable } from "@/features/pools/PoolTable";
import { useGetPoolsByDex } from "@/generated/api/pools/pools";

export const Route = createFileRoute("/pools/$dex")({ component: DexPools, validateSearch: pageSearch });

function DexPools() {
    const { dex } = Route.useParams();
    const { page = 1 } = Route.useSearch();
    const navigate = Route.useNavigate();
    // The URL counts pages from 1, the API from 0.
    const pools = useGetPoolsByDex(dex, { page: page - 1 });

    return (
        <QueryState query={pools} isEmpty={(data) => data.total === 0} emptyMessage={`No pools on ${dex} yet.`}>
            {(data) => (
                <>
                    <PoolTable pools={data.pools} label={`${dex} pools`} />
                    <Pager
                        page={page}
                        total={data.total}
                        pageSize={data.page_size}
                        noun="pools"
                        onPage={(to) => navigate({ search: { page: to } })}
                    />
                </>
            )}
        </QueryState>
    );
}
